/** 功能樹工具。systemService.getFunctions()（GET /api/system/functions·依 role_rights 過濾）回傳
 *  樹狀結構；部分 UI（功能磚 / 個人選單）以扁平清單 + upper_func_id 自行組樹，故提供攤平。
 *  攤平保留權限過濾結果（未授權功能本就不在樹中）。 */
import type { SystemFunction } from '../types';

export const flattenFunctions = (nodes: SystemFunction[]): SystemFunction[] => {
  const out: SystemFunction[] = [];
  const walk = (list: SystemFunction[]) => {
    list.forEach((f) => {
      out.push(f);
      if (f.children && f.children.length) walk(f.children);
    });
  };
  walk(nodes || []);
  return out;
};
